import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Biologybyreshma() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/05b30dd5b1154688b17c563e9366c6b9.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
        <p>HINDI    SCIENCE</p>
        <h4>Complete Course on Biology</h4> 
        <p>Lesson 13 • Mar 2, 2022 8:00 AM</p> 
        <p>Reshma Khan</p>  
        </div>
    </div>        
  )
}
export default Biologybyreshma;